"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const getMarkingColor = ({ theme, type }) => {
    switch (type) {
        case types_1.toastTypes.success: {
            return theme.markingColorSuccess;
        }
        case types_1.toastTypes.warning: {
            return theme.markingColorWarning;
        }
        case types_1.toastTypes.error: {
            return theme.markingColorError;
        }
        case types_1.toastTypes.info:
        default: {
            return theme.markingColorInfo;
        }
    }
};
exports.default = getMarkingColor;
